<template>
      <!-- <button class="submit_button">जमा करें</button> -->
        <button :class="btn_cls" @click="btnClick()">{{btn_txt}}</button>

    
</template>
<script>
export default {
  name: "Button",
  props: {
    btn_txt: {
      required: true,
      type: String
    },
    btn_cls: {
      required: true,
      type: String
    }
  },
  data() {
    return {};
  },
  methods: {
    btnClick() {
      this.$emit("submitYourReview");
      this.$emit("checkInButton");
      this.$emit("addBusiness");
      this.$emit("suggestEditBusiness");
      this.$emit("checkInBusiness");
      
    }
  }
};
</script>
